import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"

import { showSnackBar } from "../../components/Snackbar/Snackbar"
import { useMyContextLoading } from "../../components/LoadingContextProvider/LoadingContextProvider"
import Table from "./Table"
import { getAllNotes } from "../../features/notes/notes"
import DebounceInput from "../../components/DebouncedSearch/DebouncedSearch"
import TableFooter from "../../components/Pagination/TableFooter"
import usePinnedFeatureFlag from "../../hooks/usePinnedFeatureFlag"
import { NOTES_TAB_FLICKER_GUARD } from "../../config/featureFlagKeys"

const Notes = ({ userId, setTriggerUpdateSidebar, noteCreateTrigger }) => {
  const dispatch = useDispatch()
  const { triggerLoading } = useMyContextLoading()
  const { enabled: flickerGuard } = usePinnedFeatureFlag(NOTES_TAB_FLICKER_GUARD)
  const [reqError, setReqError] = useState('')
  const [notes, setNotes] = useState([])
  const [search, setSearch] = useState('')
  const [triggerDeleteNote, setTriggerDeleteNote] = useState(false)
  const [valuePagination, setValuePagination] = useState(100)
  const [pagePagination, setPagePagination] = useState(1)
  const [pageCount, setPageCount] = useState(0)


  useEffect(() => {
    const handleReqError = () => {
      reqError?.length > 0 && showSnackBar("error", reqError)
      setReqError('')
    }

    handleReqError()
  }, [reqError])

  const getUserNotes = async () => {
    triggerLoading(true)
    try {
      const limit = parseInt(valuePagination)
      const offset = (pagePagination - 1) * limit

      const response = await dispatch(getAllNotes({ userId, searchQuery: search, limit, offset }))

      if (response.payload && response.payload.data) {
        setNotes(response?.payload?.data?.notes)
        setPageCount(response?.payload?.data?.meta?.pageCount)
      } else {
        console.error('No data received from server')
      }
    } catch (error) {
      setReqError(error)
      console.error('An unexpected error occurred:', error)
    }
    triggerLoading(false)
  }


  const fetchData = async () => {
    await getUserNotes()
    setTriggerUpdateSidebar(prev => !prev)
  }

  useEffect(() => {
    if (!flickerGuard) fetchData()
  }, [])

  useEffect(() => {
    fetchData()
  }, [noteCreateTrigger, triggerDeleteNote, search, pagePagination, valuePagination])

  useEffect(() => {
    setPagePagination(1)
  }, [valuePagination])

  return (
    <div className="flex flex-col w-full">
      <div className="flex justify-between w-full mb-8">
        <div className="mx-5">
          <h5 className="mb-2.5 text-xl-20 font-bold">Notes</h5>
        </div>
      </div>
      <div className="px-4 py-5 flex border-b border-divider">
        <DebounceInput value={search} setSearchValue={setSearch} placeholder="Search" />
      </div>
      <div className="flex flex-col justify-beetwee h-full">
        <Table triggerUpdate={setTriggerDeleteNote} curUserId={userId} notes={notes} setNotes={setNotes}
          flickerGuard={flickerGuard} />
        {/* Notes is a side panel, and its pager was gated on there being more than one
            page before this moved below the table. Keeping the gate so the only change
            here is the position. */}
        {pageCount > 1 && <TableFooter page={pagePagination} limit={valuePagination} pageCount={pageCount}
          setPage={setPagePagination} setLimit={setValuePagination} />}
      </div>
    </div>
  )
}
export default Notes
